
import Gallery from '../components/Gallery';

export default function Services() {
    return (
        <div className="bg-custom-light-orange">
            <Gallery />
        </div>
    )
}